export const LEAD_CREATE_COUNTY_CREATE_REQUEST = 'LEAD_CREATE_COUNTY_CREATE_REQUEST';
export const LEAD_CREATE_COUNTY_CREATE_SUCCESS = 'LEAD_CREATE_COUNTY_CREATE_SUCCESS';
export const LEAD_CREATE_COUNTY_CREATE_FAILURE = 'LEAD_CREATE_COUNTY_CREATE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/constants/lead_create_county_create.constants.js